module.exports = __webpack_public_path__ + "img/set_theme_11.3209ffdc.png";